import { NgModule } from "@angular/core";
import { DashboardService } from './services/dashboard.service';

@NgModule({
  providers: [DashboardService]
})
export class DomainDashboardModule { }